import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageBoardComponent } from '../image-board/image-board.component';

@Component({
  selector: 'app-occurrence-block',
  templateUrl: './occurrence-block.component.html',
  styleUrls: ['./occurrence-block.component.sass'],
})
export class OccurrenceBlockComponent implements OnInit {
  @Input() occurrence: any;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
  }

  get evidences(): string[] {
    return this.occurrence?.imagens || [];
  }

  get hasEvidences(): boolean {
    return this.evidences.length > 0;
  }

  get tradeWithDivergence(): boolean {
    return this.occurrence?.comDivergencia;
  }

  get manualEntry(): boolean {
    return this.occurrence?.entradaManual;
  }

  get refused(): boolean {
    return this.occurrence?.recusado;
  }

  get divergences(): string[] {
    const list: string[] = [];

    if (this.occurrence?.telaQuebrada) {
      list.push('Tela quebrada');
    }

    if (this.occurrence?.carcacaQuebrada) {
      list.push('Carcaça quebrada');
    }

    if (this.occurrence?.aparelhoNaoLiga) {
      list.push('Aparelho não liga');
    }

    return list;
  }

  get divergenceLabel(): string {
    return this.divergences.join(', ');
  }

  openGallery(): void {
    this.dialog.open(ImageBoardComponent, {
      data: {
        idTrade: this.occurrence?.tradeId,
        images: this.occurrence?.imagens || [],
      },
      width: '70%',
      height: '80vh',
      maxWidth: '1200px',
      panelClass: 'custom-mat-dialog',
      autoFocus: false,
    });
  }
}
